import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const azTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Ad (kiçik hərf, xüsusi simvol yoxdur)',
    add: 'Əlavə et',
    allowedFileTypes: 'İcazə verilən fayl növləri',
    allowedFileTypesDescription:
      'İcazə verilən fayl növlərini məhdudlaşdırın (məsələn, şəkil/*, proqram/pdf). Bütün növlərə icazə vermək üçün boş buraxın.',
    allowMultipleFiles: 'Birdən çox fayla icazə verin',
    amountInCents: 'Qəpiklə məbləğ',
    basePrice: 'Baza Qiymət',
    bcc: 'BCC',
    brand: 'Brend',
    cc: 'CC',
    checkboxPlural: 'Yoxlama xanaları',
    checkboxSingular: 'Yoxlama qutusu',
    checkedByDefault: 'Defolt olaraq yoxlanılır',
    chooseConfirmationType:
      'Formanı təqdim etdikdən sonra səhifədəki mesajı göstərməyi və ya başqa səhifəyə yönləndirməyi seçin.',
    condition: 'Vəziyyət',
    confirmationMessage: 'Təsdiq mesajı',
    confirmationType: 'Təsdiq növü',
    countryPlural: 'Ölkə Sahələri',
    countrySingular: 'ölkə',
    creditCard: 'Kredit Kartı',
    customURL: 'Fərdi URL',
    datePlural: 'Tarix Sahələri',
    dateSingular: 'Tarix',
    defaultValue: 'Defolt Dəyər',
    divide: 'Bölmək',
    documentToLinkTo: 'Əlaqə üçün sənəd',
    doesNotEqual: 'Bərabər Deyil',
    emailFrom: 'Kimdən E-poçt',
    emailPlural: 'E-poçt Sahələri',
    emailsDescription:
      'Forma təqdim edildikdə fərdi e-poçtlar göndərin. Eyni e-poçtu birdən çox alıcıya göndərmək üçün vergüllə ayrılmış siyahılardan istifadə edin. Bu formada olan dəyərə istinad etmək üçün həmin sahənin adını ikiqat qıvrımlı mötərizələrlə sarın, məsələn, {{firstName}}. Siz bütün məlumatları çıxarmaq üçün {{*}} və ya HTML cədvəli kimi formatlaşdırmaq üçün {{*:table}} işarəsindən istifadə edə bilərsiniz.',
    emailSingular: 'E-poçt',
    emailTo: 'E-poçt ünvanına',
    equals: 'Bərabərdir',
    field: 'Sahə',
    fields: 'Sahələr',
    fieldWidth: 'Sahənin eni (faiz)',
    hasAnyValue: 'İstənilən Dəyəri Var',
    internalLink: 'Daxili keçid',
    label: 'Etiket',
    maxFileSize: 'Maksimum Fayl Ölçüsü (bayt)',
    maxFileSizeDescription: 'Baytlarda maksimum fayl ölçüsü. Limitsiz boş buraxın.',
    message: 'Mesaj',
    messageDescription: 'Bu e-poçtda göndərilməli olan mesajı daxil edin.',
    messagePlural: 'Mesaj blokları',
    messageSingular: 'Mesaj',
    mimeType: 'MIME növü',
    mimeTypePlural: 'MIME növləri',
    mimeTypeSingular: 'MIME növü',
    multiply: 'Çoxalmaq',
    numberPlural: 'Nömrə Sahələri',
    numberSingular: 'Nömrə',
    optionPlural: 'Seçimlər',
    optionSingular: 'Seçim',
    paymentFieldPlural: 'Ödəniş sahələri',
    paymentFieldSingular: 'Ödəniş',
    paymentProcessor: 'Ödəniş prosessoru',
    paymentStatus: 'Vəziyyət',
    placeholder: 'Yer tutucu',
    priceConditions: 'Qiymət Şərtləri',
    priceConditionsPlural: 'Qiymət Şərtləri',
    priceConditionsSingular: 'Qiymət Vəziyyəti',
    radioOptions: 'Radio Atribut Seçimləri',
    radioPlural: 'Radio sahələri',
    radioSingular: 'Radio',
    redirect: 'İstiqamətləndirmə',
    replyTo: 'Cavab verin',
    required: 'Tələb olunur',
    selectOptions: 'Seçimlər seçin',
    selectPlural: 'Sahələri seçin',
    selectSingular: 'seçin',
    statePlural: 'Dövlət Sahələri',
    stateSingular: 'dövlət',
    staticValue: 'Statik dəyər',
    subject: 'Mövzu',
    submitButton: 'Düymə Etiketini Göndər',
    subtract: 'Çıxar',
    textareaPlural: 'Textarea sahələri',
    textareaSingular: 'Mətn sahəsi',
    textPlural: 'Mətn Sahələri',
    textSingular: 'Mətn',
    title: 'Başlıq',
    token: 'nişan',
    uploadCollection: 'Kolleksiyanı yükləyin',
    uploadCollectionDescription: 'Faylları saxlamaq üçün hansı yükləmə kolleksiyasını seçin',
    uploadFieldPlural: 'Sahələri Yükləyin',
    uploadFieldSingular: 'Yüklə',
    urlToRedirectTo: 'Yönləndirmə üçün URL',
    value: 'Dəyər',
    valueOfField: 'Sahənin Dəyəri',
    valueType: 'Dəyər Tipi',
  },
}

export const az: PluginLanguage = {
  dateFNSKey: 'az',
  translations: azTranslations,
}
